import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Link, useNavigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./auth";
import Optin from "./pages/Optin";
import AuthVerify from "./pages/AuthVerify";
import Quiz from "./pages/Quiz";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import AdminAccept from "./pages/AdminAccept";

function Protected({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="frame"><p className="hint" data-testid="loading-indicator">One sec…</p></div>;
  }
  if (!user) return <Navigate to="/optin" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

export function Header({ favCount, onFavClick, showNav = true }) {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  return (
    <header className="top">
      <Link to="/" className="brand" style={{ textDecoration: "none" }}><b>Oracle BFF</b></Link>
      <div className="header-links">
        {user && (
          <Link className="header-link" data-testid="retake-quiz-link" to="/?start=1">Retake Quiz</Link>
        )}
        {user && (
          <Link className="header-link" data-testid="dashboard-link" to="/dashboard">My Results</Link>
        )}
        {user && (
          <Link className="header-link" data-testid="owned-nav-link" to="/?owned=1">My Decks</Link>
        )}
        {showNav && user && (
          <button className="fav-nav" data-testid="favorites-nav-button" type="button" onClick={onFavClick}>
            ♥ <span data-testid="favorites-count">{favCount}</span>
          </button>
        )}
        {user?.role === "admin" && (
          <Link className="header-link" data-testid="admin-link" to="/admin">Admin</Link>
        )}
        {user && (
          <button className="header-link" data-testid="sign-out-button" type="button"
            onClick={() => { signOut(); navigate("/optin"); }}>Sign out</button>
        )}
      </div>
    </header>
  );
}

export function Footer() {
  return (
    <footer className="credit">
      <div className="credit-ai-note">The Oracle BFF app is the brain child of Jen Rinehart. Jen hand-picked the decks and did most of the categorizing for the quiz. AI helped where Jen got stuck and did the programming of the app itself.</div>
      <div className="credit-divider"></div>
      &copy;2026 Institute for Oracle Science (formerly Intuition School) | Jen Rinehart<br />
      For Support Issues or Questions, please email me at{" "}
      <a href="mailto:jen@jenniferblumenthal.com">jen@jenniferblumenthal.com</a><br />
      <a href="https://institutefororaclescience.com/privacy" target="_blank" rel="noopener">Privacy Policy</a>
      {" | "}
      <a href="https://institutefororaclescience.com/terms" target="_blank" rel="noopener">Terms &amp; Conditions</a>
    </footer>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/optin" element={<Optin />} />
            <Route path="/auth/verify" element={<AuthVerify />} />
            <Route path="/admin/accept" element={<AdminAccept />} />
            <Route path="/" element={<Protected><Quiz /></Protected>} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
